// paginate.js

import { createSelector } from "reselect";

export const INITIAL_STATE = {
  traces: {
    offset: 0,
    length: 15,
  },
};

// action types
const NEXT_PAGE = "trace-web/paginate/NEXT_PAGE";
const PREVIOUS_PAGE = "trace-web/paginate/PREVIOUS_PAGE";

// reducer
const paginateReducer = (state = INITIAL_STATE, action = {}) => {
  var offset, length;
  switch (action.type) {
    case NEXT_PAGE:
      offset = state[action.resource].offset;
      length = state[action.resource].length;
      return {
        ...state,
        [action.resource]: {
          offset: offset + length,
          length: length,
        },
      };
    case PREVIOUS_PAGE:
      offset = state[action.resource].offset;
      length = state[action.resource].length;
      return {
        ...state,
        [action.resource]: {
          offset: Math.max(0, offset - length),
          length: length,
        },
      };
    default:
      return state;
  }
};
export default paginateReducer;

// action creators
export const nextPage = resource => {
  return {
    type: NEXT_PAGE,
    resource,
  };
};

export const previousPage = resource => {
  return {
    type: PREVIOUS_PAGE,
    resource,
  };
};

// selectors
export const getPage = selector => {
  return createSelector(
    [selector],
    resource => Math.ceil(resource.offset / resource.length) + 1
  );
};
